import { faLockAlt } from '@fortawesome/pro-regular-svg-icons/faLockAlt';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { selectUser } from '@propertypal/shared/src/reducers/user';
import { Note } from '@propertypal/shared/src/types/notes';
import { Property } from '@propertypal/shared/src/types/property';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useTheme } from 'styled-components';
import NoteItem from './NoteItem';
import { NotesInfo, NotesInfoContainer } from './Notes.style';

interface NoteItemsProps {
  property: Property;
  notes?: Note[];
  onNoteUpdate?: () => void;
}

const NoteItems: React.FC<NoteItemsProps> = ({ property, notes, onNoteUpdate }) => {
  const [notificationText, setNotificationText] = useState<string | undefined>();
  const [updating, setUpdating] = useState<boolean>(false);
  const user = useSelector(selectUser);
  const theme = useTheme();
  const selfAuthored = notes && notes.filter((n) => n.selfAuthored);
  const showAddNewNote = !!(selfAuthored && selfAuthored.length === 0) || !notes;

  return (
    <>
      <NotesInfoContainer className="pp-notes-info-text">
        <FontAwesomeIcon icon={faLockAlt} color={theme.textDark} style={{ marginRight: 10 }} />
        <NotesInfo>These notes are private, only you and your pals can see them</NotesInfo>
      </NotesInfoContainer>
      <div data-testid={`profile-${user?.profile ? 'loaded' : 'loading'}`}>
        {notes &&
          notes?.length > 0 &&
          notes.map((n) => (
            <NoteItem
              key={n.compoundKey}
              note={n}
              notificationText={notificationText}
              setNotificationText={setNotificationText}
              updating={updating}
              setUpdating={setUpdating}
              onNoteUpdate={onNoteUpdate}
            />
          ))}

        {showAddNewNote && (
          <NoteItem
            note={{
              id: property?.id,
              content: '',
              authorAvatar: user?.profile?.avatarUrl || '',
              selfAuthored: true,
              timeModified: '',
              zone: '',
              compoundKey: '',
              firstName: user?.profile?.firstName || '',
              surname: user?.profile?.lastName || '',
            }}
            notificationText={notificationText}
            setNotificationText={setNotificationText}
            updating={updating}
            setUpdating={setUpdating}
            testID="add-note-item"
            onNoteUpdate={onNoteUpdate}
          />
        )}
      </div>
    </>
  );
};

export default NoteItems;
